import React, {Component} from "react";
import {getStateAwareUrl, isSuperuser, isTrue, openEndPoint} from "../../utils/utils";
import {Col, Icon, Layout, Row} from "antd";
import {Link} from "react-router-dom";
import {ArrowBackOutlined} from "@mui/icons-material";
import {
    BgColorsOutlined,
    ControlOutlined,
    CopyOutlined,
    ExpandOutlined,
    FilterOutlined,
    MobileOutlined,
    ReloadOutlined,
    ShareAltOutlined,
    SlidersOutlined,
    ToolOutlined,
    DeleteOutlined
} from "@ant-design/icons";
import {connect} from "react-redux";
import {get, get_response} from "../../helper/request";
import {error_manager} from "../../helper/error_manager";
import {reloadDeviceConfig} from "../../utils/device_utils";
import {Spin, Switch} from 'antd';
import {antdSpinLoaderIcon} from "../../utils/const";

const {Content} = Layout;

class ScannerSettings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isBusy: false,
            deviceId: this.props.match.params.id,
            loading: false,
            crashOnTooMuchTilt: "",
        }
    }

    componentDidMount() {
        this.setState({loading: true});
        let url = `/server/devices/` + this.state.deviceId + `/toggle_crash_tilt/?is_toggle=${false}`;
        get_response(url)
            .then(response => {
                this.setState({loading: false, crashOnTooMuchTilt: isTrue(response.data)});
            })
    }

    toggleCrashOnTilt = () => {
        this.setState({loading: true});
        let url = `/server/devices/` + this.state.deviceId + `/toggle_crash_tilt/?is_toggle=${true}`;
        get_response(url)
            .then(response => {
                this.setState({loading: false, crashOnTooMuchTilt: isTrue(response.data)});
            })
    }

    reloadSettings = () => {
        reloadDeviceConfig(this.state.deviceId,
            () => this.setState({isBusy: true}),
            () => this.setState({isBusy: false}),
            () => this.setState({isBusy: false})
        )
    }

    takeLastScan = (url) => {
        get(url).then(() => {
            openEndPoint('/scanners/' + this.state.deviceId, false, true);
        }).catch(error => {
            error_manager("Failed to fetch api for last scan", error)
        })
    }


    render() {
        const {deviceId} = this.state
        const is_superuser = isSuperuser();


        return (
            <Spin indicator={antdSpinLoaderIcon} style={{marginTop: 75}} spinning={this.state.loading}>
                <Content className={"full-parent"} style={{padding: '24px'}}>
                    <Row>
                        <Row style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            height: '50px',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            padding: '30px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                            zIndex: '1000',
                        }} className={"settings-header"}>
                            <Link to={"/scanners/" + deviceId}>
                                <ArrowBackOutlined style={{fontSize: "32px"}}/>
                            </Link>
                            <div className={"flex-center full-width"}>
                                <h1 style={{fontSize: "38px", textAlign: "center", margin: 0}}>Scanner Settings</h1>
                            </div>
                        </Row>

                        <Row>
                            <Col span={14} offset={10} style={{marginTop: 50}}>
                                <span style={{marginRight: 10}}>
                                    Toggle Crash On Too Much Tilt Value (Currently <b>{this.state.crashOnTooMuchTilt ? "On" : "Off"}</b>)
                                </span>
                                <Switch checked={this.state.crashOnTooMuchTilt} onChange={this.toggleCrashOnTilt} />
                            </Col>
                            <Col span={is_superuser ? 18 : 12} offset={is_superuser ? 3 : 9} style={{marginTop: 50}}>
                                <Row className="scanner-main-control-buttons">
                                    <Col span={6}>
                                        <a href={getStateAwareUrl("/stagecleaner/" + deviceId + "/")}
                                           className="scanner-user-controls">
                                            <Row><MobileOutlined className="scanner-main-control-icon"/></Row>
                                            <Row className="arial-font">Stage Maintenance</Row>
                                        </a>
                                    </Col>
                                    <Col span={6}>
                                        <a href={getStateAwareUrl("/objectivecleaner/" + deviceId + "/")}
                                           className="scanner-user-controls">
                                            <Row><FilterOutlined className="scanner-main-control-icon"/></Row>
                                            <Row className="arial-font">Objective Cleaning</Row>
                                        </a>
                                    </Col>
                                    {is_superuser && <Col span={6}>
                                        <Link className="scanner-user-controls" to={"/manualmode/" + deviceId + "/"}>
                                            <Row><SlidersOutlined style={{color: "#d63031"}}
                                                                  className="scanner-main-control-icon"/></Row>
                                            <Row className="arial-font">Manual Mode</Row>
                                        </Link>
                                    </Col>}
                                    {is_superuser && <Col span={6}>
                                        <a href={getStateAwareUrl("/vignette_diagnostics/" + deviceId + "/")}
                                           className="scanner-user-controls">
                                            <Row><ExpandOutlined className="scanner-main-control-icon"/></Row>
                                            <Row className="arial-font">Scanner Calibration</Row>
                                        </a>
                                    </Col>}
                                </Row>
                            </Col>
                        </Row>;

                        {is_superuser && <Row style={{marginTop: 30}}>
                            <Col span={20} offset={4}>
                                <Row className="scanner-main-control-buttons">
                                    <Col span={4}>
                                        <a onClick={() => this.takeLastScan(getStateAwareUrl('/server/devices/' +
                                            deviceId + '/take_last_scan/?scan_speed=FAST'))}
                                           className="scanner-user-controls">
                                            <Row style={{color: "#f39c12"}}><CopyOutlined
                                                className="scanner-main-control-icon-retake"/></Row>
                                            <Row className="arial-font">Retake Fast</Row>
                                        </a>
                                    </Col>
                                    <Col span={4}>
                                        <a onClick={() => this.takeLastScan(getStateAwareUrl('/server/devices/' +
                                            deviceId + '/take_last_scan/?scan_speed=MEDIUM'))}
                                           className="scanner-user-controls">
                                            <Row style={{color: "#f39c12"}}>
                                                <CopyOutlined className="scanner-main-control-icon-retake"/>
                                            </Row>
                                            <Row className="arial-font">Retake Medium</Row>
                                        </a>
                                    </Col>
                                    <Col span={4}>
                                        <a onClick={() => this.takeLastScan(getStateAwareUrl('/server/devices/' +
                                            deviceId + '/take_last_scan/?scan_speed=SLOW'))}
                                           className="scanner-user-controls">
                                            <Row style={{color: "#f39c12"}}>
                                                <CopyOutlined className="scanner-main-control-icon-retake"/>
                                            </Row>
                                            <Row className="arial-font">Retake Slow</Row>
                                        </a>
                                    </Col>
                                    <Col span={4}>
                                        <a onClick={() => this.takeLastScan(getStateAwareUrl('/server/devices/' +
                                            deviceId + '/take_last_scan/?scan_speed=FAST&blur_for_threshold=true'))}
                                           className="scanner-user-controls">
                                            <Row style={{color: "#f39c12"}}>
                                                <CopyOutlined className="scanner-main-control-icon-retake"/>
                                            </Row>
                                            <Row className="arial-font">Retake with Blur</Row>
                                        </a>
                                    </Col>
                                    <Col span={4}>
                                        <a href={getStateAwareUrl('/server/devices/' + this.props.id + '/flush_saved_previews/')}
                                           className="scanner-user-controls">
                                            <Row style={{color: "#f39c12"}}><DeleteOutlined
                                                className="scanner-main-control-icon-retake"/></Row>
                                            <Row className="arial-font">Flush Saved Previews</Row>
                                        </a>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>}

                        {is_superuser && <Row style={{marginTop: 75}}>
                            <Col span={24}>
                                <Row className="scanner-main-control-buttons">
                                    <Col span={6}>
                                        <a href={getStateAwareUrl("/server/devices/" + deviceId + "/settings/tune_intra_field/")}
                                           className="scanner-user-controls">
                                            <Row><ToolOutlined className="scanner-main-control-icon"/></Row>
                                            <Row className="arial-font">Tune Intrafield</Row>
                                        </a>
                                    </Col>
                                    <Col span={6}>
                                        <a href={getStateAwareUrl("/server/devices/" + deviceId + "/settings/tune_camera/")}
                                           className="scanner-user-controls">
                                            <Row><BgColorsOutlined className="scanner-main-control-icon"/></Row>
                                            <Row className="arial-font">Exposure &amp; White Balance</Row>
                                        </a>
                                    </Col>
                                    <Col span={6}>
                                        <a href={getStateAwareUrl("/server/devices/" + deviceId + "/settings/preview_tuning/")}
                                           className="scanner-user-controls">
                                            <Row><ControlOutlined className="scanner-main-control-icon"/></Row>
                                            <Row className="arial-font">Preview Tuning (1x3 slides)</Row>
                                        </a>
                                    </Col>
                                    <Col span={6}>
                                        <a href={getStateAwareUrl("/server/devices/" + deviceId + "/settings/mapping_fine_tune/")}
                                           className="scanner-user-controls">
                                            <Row><ShareAltOutlined className="scanner-main-control-icon"/></Row>
                                            <Row className="arial-font">Mapping Fine Tune (1x3 slides)</Row>
                                        </a>
                                    </Col>
                                    <Col span={24} style={{marginTop: 20}}></Col>
                                    <Col span={6} onClick={this.reloadSettings}>
                                        <div className="scanner-user-controls">
                                            <Row><ReloadOutlined className="scanner-main-control-icon"/></Row>
                                            <Row className="arial-font">Reload Settings</Row>
                                        </div>
                                    </Col>
                                    <Col span={6}>
                                        <a href={getStateAwareUrl('/server/devices/' + deviceId + '/manualmode/')}
                                           className="scanner-user-controls">
                                            <Row><Icon type="sliders" className="scanner-main-control-icon"/></Row>
                                            <Row className="arial-font">Old Manual Mode</Row>
                                        </a>
                                    </Col>
                                    <Col span={6}>
                                        <a href={getStateAwareUrl("/server/devices/" + deviceId + "/settings/preview_tuning_2by3/")}
                                           className="scanner-user-controls">
                                            <Row><ControlOutlined className="scanner-main-control-icon"/></Row>
                                            <Row className="arial-font">Preview Tuning (2x3 slides)</Row>
                                        </a>
                                    </Col>
                                    <Col span={6}>
                                        <a href={getStateAwareUrl("/server/devices/" + deviceId + "/settings/mapping_fine_tune_2by3/")}
                                           className="scanner-user-controls">
                                            <Row><ShareAltOutlined className="scanner-main-control-icon"/></Row>
                                            <Row className="arial-font">Mapping Fine Tune (2x3 slides)</Row>
                                        </a>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>}

                    </Row>
                </Content>
            </Spin>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
};

export default connect(mapStateToProps)(ScannerSettings);